import React, { useMemo} from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setFilter } from '../../../../redux/layer_settings/Actions';

import LayerFilters from './LayerFilters';

const propTypes = {
    systemName: PropTypes.string.isRequired
};

function LayerFiltersReduxWrapper ({ systemName }) {
    const dispatch = useDispatch();
    const dispatchSetFilters = (uid, filters) => dispatch(setFilter(uid, filters));
    const fields = useSelector(state => {
        return state.layers.layers.find(el => el.system_name === systemName);        
    }, (prevFields, nextFields) => {        
        return shallowEqual(prevFields, nextFields)
    })

    const memoizedFields = useMemo(() => {
        return {
            ...(fields && fields.filterConfig ? fields.filterConfig.fields : {})
        };
    }, [fields]);


    const filters = useSelector(state => {
        const settings = state.layerSettingsReducer.find(setting => setting.uid === systemName);
        return (settings && settings.filters) || {
            id: 'root',
            not: false,
            type: 'group',
            children: [],
            conjunction: 'and'
        };
    });

    return (
        <LayerFilters
            systemName={systemName}
            fields={memoizedFields}
            filters={filters}
            onSetFilters={dispatchSetFilters}
        />
    );
}

LayerFiltersReduxWrapper.propTypes = propTypes;

export default LayerFiltersReduxWrapper;